var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"triple-arrow-button"},[_c('div',{staticClass:"triple-arrow-button__inner",class:{
    'triple-arrow-button__inner--small': _vm.small,
  }},[_c('span',[_vm._v(_vm._s(_vm.text || _vm.$translate("user_guide.step_1.create_product")))]),_c('span',[_c('triple_arrows')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }